// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.investment-strategy-form[data-v-d9bb65a2] {\n    margin: 2em 0;\n}\n", ""]);
// Exports
module.exports = exports;
